import { useEffect, useState } from 'react';
import useOrgPreferences from '@/hooks/useOrgPreferences';

const DEFAULT_REPORTING_YEAR = 2020;

export function useSelectedReportingYear() {
  const { orgPreferences } = useOrgPreferences();
  const { availableReportingYears } = orgPreferences;

  const [selectedReportingYear, setSelectedReportingYear] = useState<number>(
    () => availableReportingYears.at(-1) ?? DEFAULT_REPORTING_YEAR,
  );

  useEffect(() => {
    if (availableReportingYears.length > 0) {
      setSelectedReportingYear(availableReportingYears.at(-1) ?? DEFAULT_REPORTING_YEAR);
    }
  }, [availableReportingYears]);

  return { selectedReportingYear, setSelectedReportingYear };
}
